import Vue from "vue";
import router from "../router";
import store from "../vuex/store";
import NcmUsuarioService from "../services/NcmUsuarioService";
import configs from "../configs";

const errorCodes = [401, 403, 404, 422];
const IPs = Object.values(configs);
let originalResponse = false;

const expirationLogout = (error) => {
  store.dispatch("setUser", {});
  store.dispatch("setCompany", {});
  router.push({ name: "Login" });
  Vue.prototype.$messages
    .error()
    .toast(error || "Sua sessão expirou, efetue o login novamente.");
};

export default (http) => {
  http.interceptors.request.use(
    (request) => {
      Vue.prototype.$Progress.start();
      const usr = store.getters.getUser;
      if (usr) {
        if (
          IPs.some((ip) => request.url.includes(ip)) ||
          request.url.includes("http://localhost")
        ) {
          const token = store.getters.getToken;
          request.headers.Authorization = `Bearer: ${token}`;
        }
      }
      return request;
    },
    (error) => {
      Vue.prototype.$Progress.fail();
      return Promise.reject(error);
    },
  );

  http.interceptors.response.use(
    (response) => {
      Vue.prototype.$Progress.finish();
      response.body = response.data;
      return response;
    },
    async (error) => {
      Vue.prototype.$Progress.fail();
      if (error.response && error.response.status === 403)
        expirationLogout(error.response.data.error);
      if (
        error.response &&
        error.response.status === 401 &&
        !originalResponse
      ) {
        try {
          originalResponse = true;
          const { status, data } = await NcmUsuarioService.refreshToken();
          if (status === 200) {
            store.dispatch("refreshToken", data.accessToken);
            return Vue.prototype.$http(error.config);
          }
        } catch (error) {
          const statusCode = error.status ? error.status : null;
          if (errorCodes.includes(statusCode)) {
            expirationLogout(error.response.data.error);
          }
        }
      }
      return Promise.reject(error.response);
    },
  );
};
